import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type PermissionObject ={
  [moduleName: string]: {
    allow_all: boolean;
    read: boolean;
    write: boolean;
    create: boolean;
    delete: boolean;
    export: boolean;
  };
}

interface AuthState {
  token: string | null;
  role: string | null;
  email: string | null; // from `sub`
  name: string | null;  // from `user`
  employeeId: string | null;
  empDept:string | null;
  permissions: PermissionObject | null;
}

const initialState: AuthState = {
  token: null,
  role: null,
  email: null,
  name: null,
  employeeId: null,
  empDept:null,
  permissions: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (
      state,
      action: PayloadAction<{
        token: string;
        role: string;
        employee_id: string;
        sub: string;  // email
        user: string; // name
        department : string;
        permissions: PermissionObject;
      }>
    ) => {
      const { token, role, employee_id, sub, user, department,permissions,} = action.payload;

      state.token = token;
      state.role = role;
      state.employeeId = employee_id;
      state.email = sub;
      state.name = user;
      state.empDept = department;
      state.permissions = permissions;

      // Persist to localStorage
      localStorage.setItem('authToken', token);
      localStorage.setItem('authRole', role);
      localStorage.setItem('authEmployeeId', employee_id);
      localStorage.setItem('authEmail', sub);
      localStorage.setItem('authName', user);
      localStorage.setItem('authDept', department);
      localStorage.setItem("authPermissions", JSON.stringify(permissions));
    },

    logout: (state) => {
      state.token = null;
      state.role = null;
      state.employeeId = null;
      state.email = null;
      state.name = null;
      state.empDept = null;
      state.permissions = null;

      // Clear localStorage
      localStorage.clear();
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
